import { useContext } from 'react';
import ThemeContext from '../context';
export default function useThemeContext() {
    return useContext(ThemeContext);
}
